import { Lock } from 'lucide-react';

import { cn } from '@/shared/utils/cn';

export function CourseCardUnavailableBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'text-navy shadow-(--shadow-md) inline-flex h-6 w-fit items-center gap-1.5 rounded-lg border border-white/80 bg-white/95 px-3 text-[0.64rem] font-bold leading-none backdrop-blur-sm',
        className,
      )}
    >
      <Lock aria-hidden="true" className="h-3 w-3 shrink-0 translate-y-[0.5px]" strokeWidth={2.4} />
      <span className="mt-0.5 leading-none">No disponible</span>
    </span>
  );
}
